import { IconButton } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const LinkBox = styled.div`
  background-color: var(--color-components-modal-body-bg);
  border: 1px solid var(--color-blue-50);
  border-radius: var(--size-border-radius-md);
  color: var(--color-blue-500);
  flex-grow: 1;
  max-height: 44px;
  overflow: hidden;
  padding: 8px 16px;
  padding-right: 40px;
  position: relative;

  ${IconButton.S?.IconButton} {
    position: absolute;
    right: 8px;
    top: 8px;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  ${({ active }) =>
    !active &&
    css`
      align-items: center;
      background-color: var(--color-gray-50);
      border: 1px solid var(--color-accent-secondary-weaker);
      color: var(--color-accent-secondary-default);
      display: flex;
      justify-content: center;
      text-align: center;
    `}

  &:hover p {
    animation: scroll-left 10s linear infinite;
  }

  @keyframes scroll-left {
    0% {
      text-indent: 0;
    }
    100% {
      text-indent: -100%;
    }
  }
`;

const LinkBoxText = styled.p`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  cursor: pointer;
  display: -webkit-box;
  overflow: hidden;
  word-break: break-all;
`;

const LinkBoxIconButton = styled(IconButton)`
  position: relative;

  &::before,
  &::after {
    border: 2px solid var(--color-accent-primary-default);
    border-radius: 50%;
    content: '';
    height: 20px;
    left: 50%;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    pointer-events: none;
    background-color: var(--color-bg-body);
    cursor: pointer;
  }

  &:hover::before {
    animation: ripple-infinite 1s ease-out infinite;
  }

  &:hover::after {
    animation: ripple-infinite 1s ease-out infinite 0.5s;
  }

  @keyframes ripple-infinite {
    0% {
      width: 10px;
      height: 10px;
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
    100% {
      width: 24px;
      height: 24px;
      opacity: 0;
      transform: translate(-50%, -50%) scale(1.2);
    }
  }
`;

export { LinkBox, LinkBoxIconButton, LinkBoxText };
